var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6499 15.75C14.0437 14.4416 14.8599 13.326 15.6679 12.2145C15.8812 11.9232 16.0945 11.632 16.2996 11.3367C17.1117 10.1678 17.5874 8.75273 17.5874 7.22285C17.5874 3.23203 14.3554 0 10.3687 0C6.38198 0 3.14995 3.23203 3.14995 7.21875C3.14995 8.74863 3.62573 10.1678 4.43784 11.3326C4.64292 11.6279 4.8562 11.9191 5.06948 12.2104C5.88159 13.3219 6.6978 14.4416 7.08745 15.7459H13.6499V15.75ZM10.3687 21C12.1816 21 13.6499 19.5316 13.6499 17.7188V17.0625H7.08745V17.7188C7.08745 19.5316 8.55581 21 10.3687 21ZM7.08745 7.21875C7.08745 7.57969 6.79214 7.875 6.4312 7.875C6.07026 7.875 5.77495 7.57969 5.77495 7.21875C5.77495 4.67988 7.82983 2.625 10.3687 2.625C10.7296 2.625 11.0249 2.92031 11.0249 3.28125C11.0249 3.64219 10.7296 3.9375 10.3687 3.9375C8.55581 3.9375 7.08745 5.40586 7.08745 7.21875Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfos);
export default __webpack_public_path__ + "static/media/icon-infos.a831a70b4e802e9ccd0b41aef839a997.svg";
export { ForwardRef as ReactComponent };